import React, { ReactElement, cloneElement } from "react";
import { Col, Typography, Dropdown, Space, Divider, Row, Image } from "antd";
import { DownOutlined, UserOutlined, MailOutlined, WechatOutlined, LoginOutlined } from "@ant-design/icons";
import "./index.scss";
import type { MenuProps } from "antd";
import userImage from "assets/images/userDemo.png";
import { useAppDispatch, useAppSelector } from "hooks";
import { Logout, getUserDetails } from "redux/features/authSlice";
import { useNavigate } from "react-router-dom";
import { userLogout } from "services/authService";
import CustomBreadCrumb from "components/shared/customBreadcrumb/customBreadcrumb";
const { Text } = Typography;

function CustomHeader(): ReactElement {
  const dispatch = useAppDispatch();
  const UserDetails = useAppSelector(getUserDetails);
  const navigate = useNavigate();
  const onClickLogout = async (): Promise<void> => {
    await userLogout();
    dispatch(Logout());
    localStorage.clear();
    clearAllCookies();
    navigate("../auth");
  };

  const clearAllCookies = (): void => {
    const cookies = document.cookie.split(";");

    for (const cookie of cookies) {
      const [cookieName] = cookie.split("=");
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: <a>Profile</a>,
      icon: <UserOutlined className={"headerDropDownIcon"} />,
      className: "items"
    },
    {
      key: "2",
      label: <a>Inbox</a>,
      icon: <MailOutlined className={"headerDropDownIcon"} />,
      className: "items"
    },
    {
      key: "3",
      label: <a>Chat</a>,
      icon: <WechatOutlined className={"headerDropDownIcon"} />,
      className: "items"
    },
    {
      type: "divider"
    },
    {
      key: "4",
      label: <a>Logout</a>,
      icon: <LoginOutlined className={"headerDropDownIcon"} />,
      className: "items",
      onClick: onClickLogout
    }
  ];

  return (
    <div className={"header-wrapper"}>
      <div className={"breadcrumb-wrapper"}>
        <CustomBreadCrumb />
      </div>

      <div className={"header"}>
        <div className={"intro"}>
          <div>
            <Text className={"teamTB"}>teamtb</Text>
          </div>
          <div>
            <Text className={"UAN"}>UAN: 111-832-682</Text>
          </div>
        </div>
        <div>
          <Image
            src={userImage}
            rootClassName="headerUserImage"
            alt="Picture of the author"
            style={{ borderRadius: "50%" }}
            preview={false}
          />
        </div>
        <div>
          <Row>
            <Text className={"userName"}>{UserDetails.name}</Text>
          </Row>
          <Row>
            <Text className={"role"}>{UserDetails.userType.key}</Text>
          </Row>
        </div>

        <div style={{ top: 10 }}>
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            overlayClassName="customHeaderDropdown"
            dropdownRender={(menu): ReactElement => (
              <div className={"headerDropDown"}>
                <Row style={{ padding: 20 }}>
                  <Col span={10}>
                    <Image
                      alt="Picture of the user"
                      src={userImage}
                      rootClassName={"userImage"}
                      preview={false}
                    />
                  </Col>
                  <Col span={14}>
                    <Row>
                      <Text type="secondary">{UserDetails.name}</Text>
                    </Row>
                    <Row>
                      <Text className={"role"}>{UserDetails.userType.key}</Text>
                    </Row>
                  </Col>
                </Row>
                <Divider style={{ margin: 0 }} />
                {cloneElement(menu as React.ReactElement, {
                  style: {
                    boxShadow: "none"
                  }
                })}
              </div>
            )}
          >
            <a onClick={(e): void => e.preventDefault()}>
              <Space>
                <DownOutlined className={"headerIconDropdown"} />
              </Space>
            </a>
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

export default CustomHeader;
